import React, { useEffect, useState } from "react";
import Header from "../../../components/dashboard/Header";
import { useForm } from "react-hook-form";
import InputField from "../../../components/general/InputField";
import { useNavigate } from "react-router-dom";
import { API } from "../../../api";
import {
  addSubscriptionRecall,
  subscriptionRecallschema,
} from "../../../validations/subscriptionRecall";
import { yupResolver } from "@hookform/resolvers/yup";
import { errorToast, successToast } from "../../../hooks/useToast";
import ButtonComponent from "../../../components/general/ButtonComponent";

const AddSubscription = () => {
  const [isInvalid, setIsInvalid] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const durationMode = [
    {
      id: "days",
      key: "days",
      name: "days",
    },
    {
      id: "years",
      key: "years",
      name: "years",
    },
    {
      id: "months",
      key: "months",
      name: "months",
    },
  ];

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(addSubscriptionRecall) });

  const [allrecalls, setAllRecall] = useState([]);

  const getData = async () => {
    try {
      const response = await API.getAllRecalls();
      setAllRecall(response?.data?.data);
    } catch (error) {
      errorToast(error, "Cannot fetch recalls");
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await API.addSubscriptionRecall(data);
      successToast(response?.data?.message);
      setLoading(false);
      navigate(-1);
    } catch (error) {
      setLoading(false);
      errorToast(error, "Cannot add Subscription Recall");
    }
  };

  const handleCancle = () => {
    navigate(-1);
  };

  return (
    <div className="page-area mt-10">
      <Header
        pagetitle={"Add Subscription Recall"}
        previous={"Dashboard"}
        currentpage={"Subscription Recall Packages"}
      />
      <form className="grid grid-col-1 gap-6" onSubmit={handleSubmit(onSubmit)}>
        <div className="page-comp bg-white mt-10 rounded-xl px-8 py-8">
          <div className="grid grid-col-1 sm:grid-cols-2 gap-4 mt-4">
            <InputField
              label="Subscription Recall Name"
              type="text"
              isInvalid={isInvalid}
              isRequired={true}
              placeholder="Subscription Recall Name"
              errortext="Subscription Recall Name"
              errors={errors}
              name="name"
              register={register}
            />
            <InputField
              label="Recall Name"
              placeholder="Recall Name"
              type="select"
              options={allrecalls}
              isInvalid={isInvalid}
              isRequired={true}
              errortext="Recall Name Is Required"
              errors={errors}
              name="recallId"
              register={register}
            />
          </div>

          <div className="grid grid-col-1 sm:grid-cols-2 gap-4 mt-4">
            <InputField
              label="Number Of Days"
              type="number"
              isInvalid={isInvalid}
              isRequired={true}
              placeholder="60"
              errortext="Subscription Recall Duration is Required"
              errors={errors}
              name="duration"
              register={register}
            />
            <InputField
              label="Duration Mode"
              placeholder="Duration Mode"
              type="select"
              options={durationMode}
              isInvalid={isInvalid}
              isRequired={true}
              errortext="durationMode Is Required"
              errors={errors}
              name="durationMode"
              register={register}
            />
          </div>
          <div className="grid grid-col-1 sm:grid-cols-2 gap-4 mt-4">
            <InputField
              label="Subscription Recall Price"
              type="number"
              isInvalid={isInvalid}
              isRequired={true}
              placeholder="699"
              errortext="price Is Required"
              errors={errors}
              name="price"
              register={register}
            />
            <InputField
              label="ReSubscription Recall Price"
              type="number"
              isInvalid={isInvalid}
              isRequired={false}
              placeholder="499"
              errortext="ReSubscription Recall Price is Required"
              errors={errors}
              name="reSubscriptionPrice"
              register={register}
            />
          </div>
          <div className="grid grid-col-1 sm:grid-cols-2 gap-4 mt-4">
            <InputField
              label="Status"
              type="select"
              options={[true, false]}
              isInvalid={isInvalid}
              placeholder="Status"
              isRequired={true}
              errortext="Status Is Required"
              errors={errors}
              name="isLive"
              register={register}
            />
            <InputField
              label="isTrial"
              type="select"
              options={[true, false]}
              isInvalid={isInvalid}
              placeholder="isTrial"
              isRequired={false}
              errortext="isTrial Is Required"
              errors={errors}
              name="isTrial"
              register={register}
            />
          </div>

          <div className="w-full md:w-1/4 mt-4">
            <div className="flex gap-3">
              <ButtonComponent
                type="submit"
                text="Save"
                loading={loading}
                isActive={true}
              />
              <ButtonComponent
                text="Cancel"
                isActive={true}
                btnclass={"bg-red-500"}
                onClick={() => handleCancle()}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddSubscription;
